<template>
  <div class="user-task-tip" :class="[`step-${step}`]">
    <template v-if="step === 1">
      <div class="dialog" ref="dialog">
        <div class="close" @click="quitTask"></div>
        <div class="big-text">任务1/6：单击<span class="h">蓝色三角形</span>，拖拽至<span class="h">3s</span>处</div>
        <div class="text">拖动时间轴指针，可以更改画布定位，进行内容修改。</div>
      </div>
      <div class="arrow"></div>
      <div class="finger anim-slide-bottom"></div>
    </template>
    <template v-if="step === 2">
      <div class="finger anim-slide-bottom "></div>
      <div class="arrow"></div>
      <div class="dialog" ref="dialog">
        <div class="close" @click="quitTask"></div>
        <div class="quote"><i class="icon"></i> 很棒啦！您已经将画面准确定位了！</div>
        <div class="big-text">任务2/6：请<span class="h">双击文本</span>，进行修改，并单击画布任意区域完成。</div>
        <div class="text">模板中的文字支持编辑替换成您想要的文字。</div>
      </div>
    </template>
    <template v-if="step === 3">
      <div class="finger anim-slide-left"></div>
      <div class="arrow"></div>
      <div class="dialog" ref="dialog">
        <div class="close" @click="quitTask"></div>
        <div class="quote"><i class="icon"></i> 太好了，您已经成功修改了文本</div>
        <div class="big-text">任务3/6：请单击一个<span class="h">角色素材</span>，将其加入布。</div>
        <div class="text">左侧面板提供各式各样的素材，您可以通过搜索/分类找到并添加您想要的素材。</div>
      </div>
    </template>
    <template v-if="step === 4">
      <div class="dialog" ref="dialog">
        <div class="close" @click="quitTask"></div>
        <div class="quote"><i class="icon smile"></i> 做得不错，人物素材已成功添加进画布了</div>
        <div class="big-text">任务4/6：拖动<span class="h">素材上方的竖杠</span>，更改入场间。</div>
        <div class="text">你可以在时间轴上设置素材的出入场时间及动画效果。</div>
      </div>
      <div class="arrow"></div>
      <div class="finger anim-slide-bottom"></div>
    </template>
    <template v-if="step === 5">
      <div class="finger anim-slide-left"></div>
      <div class="arrow"></div>
      <div class="dialog" ref="dialog">
        <div class="close" @click="quitTask"></div>
        <div class="quote"><i class="icon smile"></i> 真厉害！入场时间已修改完毕</div>
        <div class="big-text">任务5/6：单击<span class="h">第二个场景页</span>，进行场景切换</div>
        <div class="text">来画动画如同PPT，由多个页面组成，您可以在左侧切换或新增场景页，进行编辑。</div>
      </div>
    </template>
    <template v-if="step === 6">
      <div class="arrow"></div>
      <div class="dialog" ref="dialog">
        <div class="quote"><i class="icon smile"></i> 恭喜！任务即将完成，只差最后一步啦~</div>
        <div class="big-text">任务6：了解<span class="h">声音与字幕、预览、导出</span>的位置</div>
        <div class="text">动画制作完毕，你可以在此进行配音、配乐与字幕，并进行预览和导出。</div>
        <div class="footer">
          <div class="btn" @click="finishTask">完成新人任务</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    step: {
      type: Number,
      default: 0
    }
  },
  methods: {
    quitTask () {
      this.$store.commit('userTask/setViewType', 'quitting');
    },
    finishTask() {
      this.$store.commit('userTask/setViewType', 'finishing');
    }
  }
}
</script>
<style scoped lang="scss">
.user-task-tip {
  position: absolute;
  z-index: 10;
  display: flex;
}
.dialog {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 350px;
  min-height: 124px;
  padding-top: 24px;
  padding-bottom: 24px;
  background: #FFFFFF;
  border-radius: 4px;
  .close {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 12px;
    height: 12px;
    background-image: url(./images/user-task-tip-close.png);
    background-size: 100% 100%;
    cursor: pointer;
  }
  .quote {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 30px;
    background: rgba(#D9DDEA, 0.4);
    border-radius: 16px;
    font-size: 12px;
    margin-bottom: 16px;
  }
  .big-text {
    width: 100%;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    text-align: left;
  }
  .text {
    width: 100%;
    padding-left: 25px;
    padding-right: 25px;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    text-align: left;
  }
  .h {
    color: #5778FB;
  }
  .footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 24px;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      height: 40px;
      background: #5778FB;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.arrow, .finger {
  background-size: 100% 100%;
}
.step-1 {
  flex-direction: column;
  justify-content: space-between;
  height: 124px + 156px + 46px;
  .arrow {
    width: 72px;
    height: 98px;
    background-image: url(./images/step1/arrow.png);
    background-size: 100% 100%;
    margin-left: 145px;
  }
  .finger {
    width: 46px;
    height: 46px;
    background-image: url(./images/step1/finger.png);
    background-size: 100% 100%;
    margin-left: 86px;
  }
}
.step-2 {
  flex-direction: column;
  justify-content: space-between;
  height: 46px + 122px + 165px;
  .arrow {
    width: 87px;
    height: 81px;
    background-image: url(./images/step2/arrow.png);
    background-size: 100% 100%;
    margin-left: 97px;
  }
  .finger {
    width: 46px;
    height: 46px;
    background-image: url(./images/step2/finger.png);
    background-size: 100% 100%;
    margin-left: 18px;
  }
}
.step-3, .step-5 {
  justify-content: space-between;
  width: 46px + 146px + 350px;
  .arrow {
    width: 97px;
    height: 70px;
    background-image: url(./images/step3/arrow.png);
    background-size: 100% 100%;
    margin-top: 49px;
  }
  .finger {
    width: 46px;
    height: 46px;
    background-image: url(./images/step3/finger.png);
    background-size: 100% 100%;
    margin-top: -10px;
  }
}
.step-4 {
  flex-direction: column;
  justify-content: space-between;
  height: 194px + 156px + 46px;
  .arrow {
    width: 72px;
    height: 98px;
    background-image: url(./images/step4/arrow.png);
    background-size: 100% 100%;
    margin-left: 121px;
  }
  .finger {
    width: 46px;
    height: 46px;
    background-image: url(./images/step4/finger.png);
    background-size: 100% 100%;
    margin-left: 86px;
  }
}

.step-6 {
  flex-direction: column;
  justify-content: space-between;
  height: 81px + 28px + 258px;
  .arrow {
    width: 87px;
    height: 81px;
    background-image: url(./images/step6/arrow.png);
    background-size: 100% 100%;
    margin-left: 178px;
  }
}

.quote>.icon {
  width: 16px !important;
  height: 16px !important;
  background-image: url(./images/step2/emoji.png);
  background-size: 100% 100%;
  &.smile {
    background-image: url(./images/step4/emoji.png);
  }
}
.anim-slide-bottom {
  animation-name: slide-bottom;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
}
.anim-slide-left {
  animation-name: slide-left;
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
}
@keyframes slide-bottom {
  0%{
    transform: translateY(0);
  }
  100%{
    transform: translateY(10px);
  }
}
@keyframes slide-left {
  0%{
    transform: translateX(0);
  }
  100%{
    transform: translateX(-10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userTask/userTaskTip.vue